import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../i18n/getLocale';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class FuelSuppliersEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: null,
      name: null,
      email: null,
      refuel_approval_required: false,
      refuel_export_required: false,
      refuel_export_email: false,
      description: null,
      fuel_locations: {},
      fuel_locations_token: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
    this.addFuelLocations = this.addFuelLocations.bind(this);
    this.addFuelLocationsToken = this.addFuelLocationsToken.bind(this);
    this.delete = this.delete.bind(this);
  }
  // Handlers

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }


  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/fornecedor/combustivel/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/fornecedores/combustivel');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            email: responseJson.data.main.email,
            refuel_approval_required: responseJson.data.main.refuel_approval_required,
            refuel_export_required: responseJson.data.main.refuel_export_required,
            refuel_export_email: responseJson.data.main.refuel_export_email,
            locations_select: responseJson.data.locations_select,
            fuel_locations: responseJson.data.fuel_supplier_locations,
            fuel_locations_token: responseJson.data.fuel_supplier_locations_token,
            currencies_select: responseJson.data.currencies_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      email: this.state.email,
      refuel_approval_required: this.state.refuel_approval_required,
      refuel_export_required: this.state.refuel_export_required,
      refuel_export_email: this.state.refuel_export_email,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/fornecedor/combustivel', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

    // Fetch salvando a edição
    addFuelLocations(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        fuel_supplier_id: this.state.id,
        location_id: this.state.location_id,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        value: this.state.value,
        currency_id: this.state.currency_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fornecedor/combustivel/localidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status === 'success') {
            self.setState({ fuel_locations: responseJson.data });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }

    addFuelLocationsToken(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        fuel_supplier_id: this.state.id,
        location_id: this.state.token_location_id,
        date_start: this.state.token_date_start,
        date_finish: this.state.token_date_finish,
        // currency_id: this.state.token_currency_id,
        token: 1,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fornecedor/combustivel/localidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status === 'success') {
            self.setState({ fuel_locations_token: responseJson.data });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  
    delete(event) {
      var id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.FornecedoresCombustivel.EditarFornecedor.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/fornecedor/combustivel/localidade/'+id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if(responseJson.status === 'success') {
              self.setState({ fuel_locations: responseJson.data.fuel_supplier_locations, fuel_locations_token: responseJson.data.fuel_supplier_locations_token });
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.FornecedoresCombustivel.EditarFornecedor.titulo}</h3>
      <Link to="/fornecedores/combustivel" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.FornecedoresCombustivel.EditarFornecedor.formulario.Nome}</label>
              <input type="text" name="name" className="form-control" placeholder="" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.FornecedoresCombustivel.EditarFornecedor.formulario.Email}</label>
              <input type="text" name="email" className="form-control" placeholder="" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.FornecedoresCombustivel.EditarFornecedor.formulario.botaoAdicionar}</button>
          </div>
        </div>
      </form>
      <hr />
      <h3>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.titulo}</h3>
      <hr />
      <form onSubmit={this.addFuelLocations}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.formulario.Localidade}:</label>
              <Select
                className="form-field-name"
                name="location_id"
                value={this.state.location_id}
                searchable={true}
                placeholder={this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.formulario.placeholder.SelecionarLocalidade}
                onChange={this.handleSelectChange.bind(this, 'location_id')}
                options={this.state.locations_select}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.formulario.ValorLitro}:</label>
              <input type="text" placeholder="Valor/Litro" className="form-control" name="value" value={this.state.value} onChange={this.handleChange.bind(this, 'value')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.formulario.DataDeInicioDaVigencia}:</label>
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" required />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.formulario.DataDeTerminoDaVigencia}:</label>
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" required />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.formulario.Moeda}:</label>
            <Select
              className="form-field-name"
              name="currency_id"
              value={this.state.currency_id}
              searchable={true}
              placeholder={this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.formulario.placeholder.SelecionarMoeda}
              onChange={this.handleSelectChange.bind(this, 'currency_id')}
              options={this.state.currencies_select}
              required
            />
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.formulario.botaoAdicionarLocalidade}</button>
        </div>
      </form>
      <hr />
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.tabela.Localidade}</th>
              <th>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.tabela.Icao}</th>
              <th>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.tabela.InicioDaVigencia}</th>
              <th>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.tabela.TerminoDaVigencia}</th>
              <th>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.tabela.Moeda}</th>
              <th>{this.locale.FornecedoresCombustivel.EditarFornecedor.PrecosPorLocalidade.AdicionarLocalidade.tabela.Valor}</th>
              <th></th>
            </tr>
          </thead>
          <tbody id="dates">
          {Object.keys(self.state.fuel_locations).map(function(k) {
            var fuel_location = self.state.fuel_locations[k];
            return (
              <tr>
                <td>{fuel_location.location.name}</td>
                <td>{fuel_location.location.icao_code}</td>
                <td>{fuel_location.validity_start_date_str}</td>
                <td>{fuel_location.validity_end_date_str}</td>
                <td>{fuel_location.currency.alphabetical_code}</td>
                <td>{fuel_location.value_str}</td>
                <td className="text-center">
                  <button className="btn btn-sm btn-danger button-inline" value={fuel_location.id} onClick={self.delete}><i className="fa fa-fw fa-trash"></i></button>
                </td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default FuelSuppliersEdit;



// WEBPACK FOOTER //
// ./src/Components/FuelSuppliers/FuelSuppliersEdit.js